module.exports = __webpack_public_path__ + "media/character-robot-content.bfeaa60e.mp3";